import { createSpatialViewInterface, CreateSpatialView, CreateSpatialViewFailure, CreateSpatialViewSuccess, Customer, GetSpatialView, GetSpatialViewFailure, GetSpatialViewSuccess, SetAddSpatialViewOpened, UploadFileToS3, UploadFileToS3Success, UploadFileToS3Failure, SetFileUploadddSuccess, SetEditSpatialViewOpened, FetchGlbUrlPayload, FetchGlbUrl, FetchGlbUrlSuccess, FetchGlbUrlFailure, UpdateSpatialView, UpdateSpatialViewSuccess, UpdateSpatialViewFailure, DeleteSpatialView, DeleteSpatialViewSuccess, DeleteSpatialViewFailure, UpdateModelFailure, UpdateModelSuccess, UpdateModel, UpdateModelPayload, FetchSensorDevices, FetchSensorDevicesFailure, FetchSensorDevicesPayload, FetchSensorDevicesSuccess, SensorDevice, FetchTatamDevicesPayload, FetchTatamDevices, FetchTatamDevicesSuccess, FetchTatamDevicesFailure, InstallSpatialViewDevicePayload, InstallSpatialViewDevice, InstallSpatialViewDeviceSuccess, InstallSpatialViewDeviceFailure, UninstallSpatialViewDevicePayload, UninstallSpatialViewDevice, UninstallSpatialViewDeviceSuccess, UninstallSpatialViewDeviceFailure, FetchTotalDevicesFailure, FetchTotalDevicesSuccess, FetchTotalDevices, FetchTotalDevicesPayload, StartGlbProcess, FetchLivePollingPayload, FetchLivePolling, FetchLivePollingSuccess, FetchLivePollingFailure, StopLivePolling, FetchSpatialViewOperationsPayload, FetchSpatialViewOperations, FetchSpatialViewOperationsSuccess, FetchSpatialViewOperationsFailure } from 'redux/types/spatialViewActionModel';
import * as actionTypes from '../actionTypes';
import { FailurePayload, } from 'redux/types';
import { AllocatedThingsList } from 'shared/model/SiteModel';


export const getSpatialView = (id?: number): GetSpatialView => ({
    type: actionTypes.GET_SPATIAL_VIEW,
    payload:{id}
});

export const getSpatialViewSuccess = (payload: Customer[]): GetSpatialViewSuccess => ({
    type: actionTypes.GET_SPATIAL_VIEW_SUCCESS,
    payload,
});

export const getSpatialViewFailure = (payload: FailurePayload): GetSpatialViewFailure => ({
    type: actionTypes.GET_SPATIAL_VIEW_FAILURE,
    payload,
});
export const setAddSpatialViewOpened = (payload: boolean): SetAddSpatialViewOpened => ({
    type: actionTypes.SET_ADD_SPATIAL_VIEW_OPEN,
    payload,
});

export const createSpatialView = (payload: createSpatialViewInterface): CreateSpatialView => ({
    type: actionTypes.CREATE_SPATIAL_VIEW,
    payload,
});

export const createSpatialViewSuccess = (payload: any): CreateSpatialViewSuccess => ({
    type: actionTypes.CREATE_SPATIAL_VIEW_SUCCESS,
    payload,
});

export const createSpatialViewFailure = (payload: FailurePayload): CreateSpatialViewFailure => ({
    type: actionTypes.CREATE_SPATIAL_VIEW_FAILURE,
    payload,
});
export const uploadFileToS3 = (): UploadFileToS3 => ({
    type: actionTypes.UPLOAD_FILE_TO_S3,
});
export const uploadFileToS3Success = (): UploadFileToS3Success => ({
    type: actionTypes.UPLOAD_FILE_TO_S3_SUCCESS,
});
export const uploadFileToS3Failure = (payload: FailurePayload): UploadFileToS3Failure => ({
    type: actionTypes.UPLOAD_FILE_TO_S3_FAILURE,
    payload,
});
export const setFileUploadddSuccess = (payload: boolean): SetFileUploadddSuccess => ({
    type: actionTypes.FILE_UPLOAD_SUCCESS,
    payload,
});
export const setEditSpatialViewOpened = (payload: boolean): SetEditSpatialViewOpened => ({
    type: actionTypes.SET_EDIT_SPATIAL_VIEW_OPEN,
    payload,
});

export const updateSpatialView = (payload: Partial<createSpatialViewInterface>): UpdateSpatialView => ({
    type: actionTypes.UPDATE_SPATIAL_VIEW,
    payload,
});

export const updateSpatialViewSuccess = (payload: any): UpdateSpatialViewSuccess => ({
    type: actionTypes.UPDATE_SPATIAL_VIEW_SUCCESS,
    payload,
});

export const updateSpatialViewFailure = (payload: FailurePayload): UpdateSpatialViewFailure => ({
    type: actionTypes.UPDATE_SPATIAL_VIEW_FAILURE,
    payload,
});

export const fetchGlbUrl = (payload: FetchGlbUrlPayload): FetchGlbUrl => ({
    type: actionTypes.FETCH_GLB_URL,
    payload,
});

export const fetchGlbUrlSuccess = (payload: string): FetchGlbUrlSuccess => ({
    type: actionTypes.FETCH_GLB_URL_SUCCESS,
    payload,
});

export const fetchGlbUrlFailure = (payload: FailurePayload): FetchGlbUrlFailure => ({
    type: actionTypes.FETCH_GLB_URL_FAILURE,
    payload,
});
export const deleteSpatialView = (spatial_view_id: number): DeleteSpatialView => ({
    type: actionTypes.DELETE_SPATIAL_VIEW,
    payload: { spatial_view_id },
});

export const deleteSpatialViewSuccess = (payload: any): DeleteSpatialViewSuccess => ({
    type: actionTypes.DELETE_SPATIAL_VIEW_SUCCESS,
    payload,
});

export const deleteSpatialViewFailure = (payload: FailurePayload): DeleteSpatialViewFailure => ({
    type: actionTypes.DELETE_SPATIAL_VIEW_FAILURE,
    payload,
});

export const updateModel = (payload: UpdateModelPayload): UpdateModel => ({
    type: actionTypes.UPDATE_MODEL,
    payload
});

export const updateModelSuccess = (payload: any): UpdateModelSuccess => ({
    type: actionTypes.UPDATE_MODEL_SUCCESS,
    payload,
});

export const updateModelFailure = (payload: FailurePayload): UpdateModelFailure => ({
    type: actionTypes.UPDATE_MODEL_FAILURE,
    payload,
});
export const fetchSensorDevices = (payload: FetchSensorDevicesPayload): FetchSensorDevices => ({
    type: actionTypes.FETCH_SENSOR_DEVICES,
    payload,
});

export const fetchSensorDevicesSuccess = (payload: AllocatedThingsList[]): FetchSensorDevicesSuccess => ({
    type: actionTypes.FETCH_SENSOR_DEVICES_SUCCESS,
    payload,
});

export const fetchSensorDevicesFailure = (payload: FailurePayload): FetchSensorDevicesFailure => ({
    type: actionTypes.FETCH_SENSOR_DEVICES_FAILURE,
    payload,
});

export const fetchTatamDevices = (payload: FetchTatamDevicesPayload): FetchTatamDevices => ({
    type: actionTypes.FETCH_TATAM_DEVICES,
    payload,
});

export const fetchTatamDevicesSuccess = (payload: AllocatedThingsList[]): FetchTatamDevicesSuccess => ({
    type: actionTypes.FETCH_TATAM_DEVICES_SUCCESS,
    payload,
});

export const fetchTatamDevicesFailure = (payload: FailurePayload): FetchTatamDevicesFailure => ({
    type: actionTypes.FETCH_TATAM_DEVICES_FAILURE,
    payload,
});
export const installSpatialViewDevice = (payload: InstallSpatialViewDevicePayload): InstallSpatialViewDevice => ({
    type: actionTypes.INSTALL_SPATIAL_VIEW_DEVICE,
    payload,
});

export const installSpatialViewDeviceSuccess = (payload: any): InstallSpatialViewDeviceSuccess => ({
    type: actionTypes.INSTALL_SPATIAL_VIEW_DEVICE_SUCCESS,
    payload,
});

export const installSpatialViewDeviceFailure = (payload: FailurePayload): InstallSpatialViewDeviceFailure => ({
    type: actionTypes.INSTALL_SPATIAL_VIEW_DEVICE_FAILURE,
    payload,
});

export const uninstallSpatialViewDevice = (payload: UninstallSpatialViewDevicePayload): UninstallSpatialViewDevice => ({
    type: actionTypes.UNINSTALL_SPATIAL_VIEW_DEVICE,
    payload,
});

export const uninstallSpatialViewDeviceSuccess = (payload: any): UninstallSpatialViewDeviceSuccess => ({
    type: actionTypes.UNINSTALL_SPATIAL_VIEW_DEVICE_SUCCESS,
    payload,
});

export const uninstallSpatialViewDeviceFailure = (payload: FailurePayload): UninstallSpatialViewDeviceFailure => ({
    type: actionTypes.UNINSTALL_SPATIAL_VIEW_DEVICE_FAILURE,
    payload,
});

export const fetchTotalDevices = (payload: FetchTotalDevicesPayload): FetchTotalDevices => ({
    type: actionTypes.FETCH_TOTAL_DEVICES,
    payload,
});

export const fetchTotalDevicesSuccess = (payload: any): FetchTotalDevicesSuccess => ({
    type: actionTypes.FETCH_TOTAL_DEVICES_SUCCESS,
    payload,
});

export const fetchTotalDevicesFailure = (payload: FailurePayload): FetchTotalDevicesFailure => ({
    type: actionTypes.FETCH_TOTAL_DEVICES_FAILURE,
    payload,
});

export const startGlbProcess = (payload: boolean): StartGlbProcess => ({
    type: actionTypes.START_GLB_PROCESSING,
    payload,
});
export const fetchLivePolling = (payload: FetchLivePollingPayload): FetchLivePolling => ({
    type: actionTypes.FETCH_LIVE_POLLING,
    payload,
});

export const fetchLivePollingSuccess = (payload: any): FetchLivePollingSuccess => ({
    type: actionTypes.FETCH_LIVE_POLLING_SUCCESS,
    payload,
});

export const fetchLivePollingFailure = (payload: FailurePayload): FetchLivePollingFailure => ({
    type: actionTypes.FETCH_LIVE_POLLING_FAILURE,
    payload,
});

export const stopLivePolling = (): StopLivePolling => ({
    type: actionTypes.STOP_LIVE_POLLING,
});

export const fetchSpatialViewOperations = (payload: FetchSpatialViewOperationsPayload): FetchSpatialViewOperations => ({
    type: actionTypes.FETCH_SPATIAL_VIEW_OPERATIONS,
    payload,
});

export const fetchSpatialViewOperationsSuccess = (payload: any[]): FetchSpatialViewOperationsSuccess => ({
    type: actionTypes.FETCH_SPATIAL_VIEW_OPERATIONS_SUCCESS,
    payload,
});

export const fetchSpatialViewOperationsFailure = (payload: FailurePayload): FetchSpatialViewOperationsFailure => ({
    type: actionTypes.FETCH_SPATIAL_VIEW_OPERATIONS_FAILURE,
    payload,
});
